import type { ThemeOptions } from '@mui/material/styles';
import type {} from '@mui/x-tree-view/themeAugmentation';

export const richTreeViewThemes: ThemeOptions['components'] = {
  MuiRichTreeView: {
    styleOverrides: {
      root: {},
      item: {},
      itemContent: {},
      itemCheckbox: {},
      itemGroupTransition: {},
      itemIconContainer: {},
      itemLabel: {},
    },
  },
};
